/* istanbul ignore file */
export var ItemRelationshipDirection;
(function (ItemRelationshipDirection) {
    ItemRelationshipDirection[ItemRelationshipDirection["AReferencesB"] = 0] = "AReferencesB";
    ItemRelationshipDirection[ItemRelationshipDirection["BReferencesA"] = 1] = "BReferencesA";
    ItemRelationshipDirection[ItemRelationshipDirection["NoRelationship"] = 2] = "NoRelationship";
})(ItemRelationshipDirection || (ItemRelationshipDirection = {}));
